import { ActionBase } from '../../../core/store/action/ActionBase';

export const GLOBAL_UNLOCK = '[Customer] Global Unlock';

export class GlobalUnLockAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GLOBAL_UNLOCK;
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/GlobalUnLockAction.ts